export default {
  path: 'temporary-regulations/work-orders/:id',
  name: 'TemporaryRegulationsWorkOrderDetails',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/WorkOrderDetails.vue')
}
